import { OverviewComponent } from './components/overview/overview.component';
import { SpecificationsComponent } from './components/specifications/specifications.component';
import { FitmentComponent } from './components/fitment/fitment.component';
import { DigitalAssetComponent } from './components/digital-asset/digital-asset.component';
import { ShippingComponent } from './components/shipping/shipping.component';
import { AboutComponent } from './components/about/about.component';


export const segments: Array<any> = [
  {
    segment: 'overview',
    title: 'Overview',
    active: true,
    component: OverviewComponent,
  },
  {
    segment: 'specifications',
    title: 'Specifications',
    active: false,
    component: SpecificationsComponent,
  },
  {
    segment: 'fitment',
    title: 'Fitment',
    circleIcon: false,
    active: false,
    component: FitmentComponent,
  },
  {
    name: 'digitalAssets',
    segment: 'digitalAssets',
    title: 'Digital Assets',
    active: false,
    component: DigitalAssetComponent,
  },
  {
    segment: 'shipping',
    title: 'Shipping',
    active: false,
    component: ShippingComponent,
  },
  {
    segment: 'about',
    title: 'About',
    active: false,
    component: AboutComponent,
  }
];
